import React from 'react';
import { Route, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs';
import { patchPath } from 'utils/patch-path';
import { PDPConnected } from './product-details';

const Routes = memo(function Routes() {
  return (
    <Switch>
      <Route path={patchPath('/product/:productDescriptor')}>
        <PDPConnected />
      </Route>
    </Switch>
  );
});

export { Routes };
